<template>
  <div class="case_box">
    <div class="banner">
      <img :src="banner" class="banner_img" id="home" />
    </div>
    <div class="case">
      <b-container>
        <div class="box1">
          <h1 v-if="type==1">猪肉类</h1>
          <h1 v-if="type==2">牛肉类</h1>
          <h1 v-if="type==3">羊肉类</h1>
          <h1 v-if="type==4">鸡肉类</h1>
        </div>
        <div class="case_box2 row">
          <div
            class="case_box3 col-4"
            v-for="(item, index) in data"
            :key="index"
          >
            <div class="pox">
              <img :src="item.navigation" class="case_img" />
            </div>
            <p>
              {{ item.name }}
            </p>
            <span>{{ item.intro }}</span>
          </div>
          
        </div>
        <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            aria-controls="my-table"
            align="center"
            @input="ChangePage()"
          ></b-pagination>
      </b-container>
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import axios from "axios";
import local from "../utils/local";
import { index } from "../api/api";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      active: false,
      data: [],
      banner: "",
      currentPage:1,
      total:0,
      perPage:9,
      type:""

    };
  },
  created() {
    
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted() {
    this.type=this.$route.query.data;
    this.getInfo();
  },
  watch:{
    $route: {
          handler() {
              this.type=this.$route.query.data;
              this.getInfo();
              //深度监听，同时也可监听到param参数变化
        },
        deep: true,
    }
  },
  methods: {
    getInfo() {
      index(this.type, this.currentPage, this.perPage,'').then((res) => {
        // console.log(res);
        this.banner = res.data.data.msg[0].banner;
        this.data = res.data.data.instance.data;
        this.total = res.data.data.instance.total;
      });
    },
    Back() {
      this.$router.push("/home");
    },
ChangePage(data){
  this.getInfo()
},
    look(data) {
      this.$router.push({
        path: `/details`,
        query: {
          data: JSON.stringify(data),
        },
      });
    },
  },
};
</script>

<style lang="less">
.box1 {
  text-align: center;
  margin-top: 80px;

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }

  p {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }

  span {
    color: #808080;
    font-size: 16px;
  }
}

.case_box {
  position: relative;
}
.banner {
  width: 100%;
  margin: 0 auto;

  .banner_img {
    width: 100%;
    height: 450px;
  }
}
.case {
  // padding-top: 80px;

  .return {
    font-size: 14px;
    color: #666;
    margin-top: 40px;
  }

  .case_box2 {
    margin-bottom: 50px;
    width: 100%;

    .col-4 {
      padding: 0;
    }

    .case_box3 {
      // width: 300px;
      margin-top: 80px;
      text-align: center;

      p {
        font-size: 16px;
        color: #333;
        line-height: 45px;
        margin: 0;
      }

      .pox {
        position: relative;
        width: 320px;
        height: 240px;

        .case_img {
          width: 320px;
          height: 240px;
        }

        .active {
          width: 100%;
          height: 240px;
          position: absolute;
          padding: 30px 10px;
          background: rgba(0, 0, 0, 0.5) !important;
          top: 0;
          left: 0;
          margin: 0;

          .col {
            text-align: center;

            p {
              color: #fff;
              z-index: 100;
            }

            .img {
              width: 110px;
              height: 110px;
            }
          }

          .btn {
            width: 120px;
          }
        }
      }

      span {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .look {
    width: 100%;
    text-align: center;
    color: #28a6fc;
    font-size: 14px;
  }
}
</style>